"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _segment = _interopRequireDefault(require("./segment"));

var _mpegParser = _interopRequireDefault(require("../parsers/container/mpeg-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * A MediaInitializationSegment represents a media asset that contains information
 * used to initialize an audio/video decoder
 */
var MediaInitializationSegment =
/*#__PURE__*/
function (_Segment) {
  _inherits(MediaInitializationSegment, _Segment);

  function MediaInitializationSegment(info) {
    var _this;

    _classCallCheck(this, MediaInitializationSegment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaInitializationSegment).call(this));
    _this.uri = info['URI'];
    _this.objType = 'MediaInitializationSegment';

    if (info['BYTERANGE']) {
      _this.byteRange = info['BYTERANGE'];
    }

    return _this;
  }

  _createClass(MediaInitializationSegment, [{
    key: "fetch",
    value: function fetch(onProgress) {
      var _this2 = this;

      var segmentData;
      return _get(_getPrototypeOf(MediaInitializationSegment.prototype), "fetch", this).call(this, onProgress).then(function (segment) {
        segmentData = segment;
        return _mpegParser.default.parse(segment);
      }).then(function (parsedSegment) {
        _this2.codecs = {
          codecs: parsedSegment.codecs,
          codecsString: parsedSegment.codecsString
        };
        return segmentData;
      });
    }
  }]);

  return MediaInitializationSegment;
}(_segment.default);

var _default = MediaInitializationSegment;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/segments/media-initialization-segment.js
// module id = 449
// module chunks = 0